export const FormMixin = {
    methods:{
        validateEmail() {
            var valid = /[a-z0-9.-]+@[a-z0-9.-]+\.[a-z]{2,}$/.test(this.email);
            if (valid) {
                this.emailRules = [true];
            } else if (this.email === "" || this.email === undefined) {
                this.emailRules = ["Email necessaria"];
            } else {
                this.emailRules = ["L'email deve avere un formato corretto"];
            }
        }
    }
    
}
